import httpsV2 from '../../httpsV2'

export const getUsers = (limit, offset) => {
  return httpsV2.get(`/middleware/users?limit=${limit}&offset=${offset}`)
}

export const getAllUsers = () => {
  return httpsV2.get(`/middleware/users`)
}

export const getAllUsersShallow = () => {
  return httpsV2.get(`/middleware/users/shallow`)
}

export const getUser = (id) => {
  return httpsV2.get(`/middleware/user/${id}`)
}

export const updateUser = (id, data) => {
  return httpsV2.put(`/middleware/user/${id}`, data)
}

export const createUser = (data) => {
  return httpsV2.post('/middleware/user', data)
}

export const activateUser = (id) => {
  return httpsV2.put(`/middleware/user/${id}/activate`)
}

export const deactivateUser = (id) => {
  return httpsV2.delete(`/middleware/user/${id}`)
}
